import { j as s } from "../../jsx-runtime-82a9ddf6.js";
import { useState as S, useEffect as _ } from "react";
import { UploadIcon as $ } from "../icons/icons/UploadIcon.js";
import { DownloadIcon as B } from "../icons/icons/DownloadIcon.js";
import { BalanceIcon as D } from "../icons/icons/BalanceIcon.js";
import { BankIcon as M } from "../icons/icons/BankIcon.js";
import { SwapIcon as P } from "../icons/icons/SwapIcon.js";
import { AddCircularIcon as z } from "../icons/icons/AddCircularIcon.js";
import { RefreshIcon as U } from "../icons/icons/RefreshIcon.js";
import { DotsIcon as V } from "../icons/icons/DotsIcon.js";
import { ArrowRightIcon as F } from "../icons/icons/ArrowRightIcon.js";
import { ArrowLeftIcon as H } from "../icons/icons/ArrowLeftIcon.js";
import { ArrowUpIcon as T } from "../icons/icons/ArrowUpIcon.js";
import { ArrowDownIcon as G } from "../icons/icons/ArrowDownIcon.js";
import { TrashIcon as J } from "../icons/icons/TrashIcon.js";
import { CubeIcon as K } from "../icons/icons/CubeIcon.js";
import { PlusIcon as O } from "../icons/icons/PlusIcon.js";
import { MinusIcon as Q } from "../icons/icons/MinusIcon.js";
import { FileIcon as W } from "../icons/icons/FileIcon.js";
import { HistoryIcon as X } from "../icons/icons/HistoryIcon.js";
import { SendIcon as Y } from "../icons/icons/SendIcon.js";
import { InvoiceIcon as Z } from "../icons/icons/InvoiceIcon.js";
import { RefundIcon as q } from "../icons/icons/RefundIcon.js";
import { ProcessInvoiceIcon as ee } from "../icons/icons/ProcessInvoiceIcon.js";
import { InvoiceReplacementIcon as re } from "../icons/icons/InvoiceReplacementIcon.js";
import { StopIcon as se } from "../icons/icons/StopIcon.js";
import { RestokeIcon as ae } from "../icons/icons/RestokeIcon.js";
import { ProcessCashAppIcon as oe } from "../icons/icons/ProcessCashAppIcon.js";
import { ResetDownloadsIcon as te } from "../icons/icons/ResetDownloadsIcon.js";
import { EditIcon as ne } from "../icons/icons/EditIcon.js";
import { StarIcon as me } from "../icons/icons/StarIcon.js";
import { EmptyStarIcon as ie } from "../icons/icons/EmptyStarIcon.js";
import { EmojiSadIcon as le } from "../icons/icons/EmojiSadIcon.js";
import { ManageIcon as ce } from "../icons/icons/ManageIcon.js";
import { cva as de } from "../../lib/cn.js";
const pe = de(
  "relative flex justify-center items-center overflow-hidden transition-all duration-250 ease-in-out px-4 text-center rounded-lg text-base leading-4 box-border select-none cursor-pointer",
  {
    variants: {
      variant: {
        primary: "dark:hover:bg-slate-300 font-bold dark:bg-white dark:text-slate-900 text-white bg-slate-900 shadow-[0_1px_2px_rgba(18,20,23,0.06)] hover:bg-slate-700 disabled:border-none disabled:shadow-none disabled:opacity-70",
        secondary: "dark:hover:bg-slate-900 dark:bg-slate-800 dark:border-slate-700 dark:text-slate-400 font-medium text-slate-500 bg-white border border-solid border-slate-200 shadow-[0_1px_2px_rgba(18,20,23,0.06)]  hover:bg-slate-200 hover:border hover:border-slate-200 disabled:bg-slate-100 disabled:border-none disabled:shadow-none",
        ghost: "font-medium text-slate-900 bg-transparent border-2 border-white hover:bg-slate-50 disabled:text-slate-300 disabled:border-none disabled:shadow-none",
        warning: "font-bold text-white bg-red-600 hover:bg-red-700 disabled:text-slate-300 disabled:bg-slate-100 disabled:border-none disabled:shadow-none"
      },
      size: {
        "extra-large": "h-[2.75rem]",
        large: "h-[2.25rem]",
        medium: "h-[2.25rem]",
        small: "h-[1.75rem]",
        square: ""
      }
    },
    defaultVariants: {
      variant: "primary",
      size: "large"
    }
  }
), Qe = ({
  size: x = "medium",
  variant: l = "primary",
  type: I = "button",
  iconPosition: c = "right",
  iconName: u,
  className: h,
  children: v,
  style: N,
  skip: w,
  large: y,
  square: i,
  disabled: f,
  ...E
}) => {
  const [t, L] = S(null);
  _(() => {
    if (w || !t)
      return;
    let d = !1, m = !1;
    const o = document.createElement("span"), k = (n) => {
      if (n.button === 2)
        return !1;
      d = !0, o.classList.add(
        "absolute",
        "h-2.25",
        "w-2.25",
        "rounded-full",
        "transform",
        "-translate-x-1/2",
        "-translate-y-1/2",
        "transform-gpu"
      );
      const p = t.getBoundingClientRect(), A = n.x - p.left, C = n.y - p.top, b = Math.max(p.width, p.height) * Math.PI * 1.5;
      o.style.left = `${A}px`, o.style.top = `${C}px`, o.style.backgroundColor = l === "secondary" ? "black" : "white", o.style.opacity = "0.175", m || (m = !0, t.appendChild(o));
      const R = o.animate(
        {
          height: ["0px", `${b}px`],
          width: ["0px", `${b}px`]
        },
        {
          duration: 700
        }
      );
      R.onfinish = () => {
        o.style.width = `${b}px`, o.style.height = `${b}px`;
      };
    }, g = () => {
      if (!d)
        return;
      const n = o.animate(
        {
          opacity: [0.175, 0]
        },
        {
          duration: 700 / 3
        }
      );
      n.onfinish = () => {
        m && (m = !1, o.remove());
      };
    }, j = () => {
      if (!d)
        return;
      d = !1;
      const n = o.animate(
        {
          opacity: [0.175, 0]
        },
        {
          duration: 700 / 3
        }
      );
      n.onfinish = () => {
        m && (m = !1, o.remove());
      };
    };
    return t.addEventListener("mousedown", k), t.addEventListener("mouseup", j), t.addEventListener("mouseover", g), () => {
      t.removeEventListener("mousedown", k), t.removeEventListener("mouseup", j), t.removeEventListener("mouseover", g);
    };
  }, [t, w, l]);
  let a = pe({ size: x, variant: l });
  h && (a = a + " " + h, a = a + " flex");
  let e;
  c === "right" ? e = i ? "" : "ml-2" : e = i ? "" : "mr-2", x === "small" && u ? e = e + " w-[1rem] h-[1rem] min-w-[1rem]" : e = e + " w-[1.125rem] h-[1.125rem] min-w-[1.125rem]", l === "warning" && (e = e + " white"), i && (e = e + " mx-0 ml-0 mr-0");
  let r;
  switch (u) {
    case "balance":
      r = /* @__PURE__ */ s.jsx(D, { className: e });
      break;
    case "upload":
      r = /* @__PURE__ */ s.jsx($, { className: e });
      break;
    case "download":
      r = /* @__PURE__ */ s.jsx(B, { className: e });
      break;
    case "edit":
      r = /* @__PURE__ */ s.jsx(ne, { className: e });
      break;
    case "trash":
    case "delete":
      r = /* @__PURE__ */ s.jsx(J, { className: e });
      break;
    case "star":
      r = /* @__PURE__ */ s.jsx(me, { className: e });
      break;
    case "empty-star":
      r = /* @__PURE__ */ s.jsx(ie, { className: e });
      break;
    case "plus":
      r = /* @__PURE__ */ s.jsx(O, { className: e });
      break;
    case "minus":
      r = /* @__PURE__ */ s.jsx(Q, { className: e });
      break;
    case "arrow-up":
      r = /* @__PURE__ */ s.jsx(T, { className: e });
      break;
    case "arrow-down":
      r = /* @__PURE__ */ s.jsx(G, { className: e });
      break;
    case "arrow-left":
      r = /* @__PURE__ */ s.jsx(H, { className: e });
      break;
    case "arrow-right":
      r = /* @__PURE__ */ s.jsx(F, { className: e });
      break;
    case "cube":
      r = /* @__PURE__ */ s.jsx(K, { className: e });
      break;
    case "dots":
      r = /* @__PURE__ */ s.jsx(V, { className: e });
      break;
    case "refresh":
      r = /* @__PURE__ */ s.jsx(U, { className: e });
      break;
    case "add-circular":
      r = /* @__PURE__ */ s.jsx(z, { className: e });
      break;
    case "file":
      r = /* @__PURE__ */ s.jsx(W, { className: e });
      break;
    case "invoice":
      r = /* @__PURE__ */ s.jsx(Z, { className: e });
      break;
    case "history":
      r = /* @__PURE__ */ s.jsx(X, { className: e });
      break;
    case "send":
      r = /* @__PURE__ */ s.jsx(Y, { className: e });
      break;
    case "refund":
      r = /* @__PURE__ */ s.jsx(q, { className: e });
      break;
    case "process-invoice":
      r = /* @__PURE__ */ s.jsx(ee, { className: e });
      break;
    case "invoice-replacement":
      r = /* @__PURE__ */ s.jsx(re, { className: e });
      break;
    case "process-cashapp":
      r = /* @__PURE__ */ s.jsx(oe, { className: e });
      break;
    case "stop":
      r = /* @__PURE__ */ s.jsx(se, { className: e });
      break;
    case "restoke":
      r = /* @__PURE__ */ s.jsx(ae, { className: e });
      break;
    case "reset-downloads":
      r = /* @__PURE__ */ s.jsx(te, { className: e });
      break;
    case "bank":
      r = /* @__PURE__ */ s.jsx(M, { className: e });
      break;
    case "swap":
      r = /* @__PURE__ */ s.jsx(P, { className: e });
      break;
    case "manage":
      r = /* @__PURE__ */ s.jsx(ce, { className: e });
      break;
    case "emoji-sad":
      r = /* @__PURE__ */ s.jsx(le, { className: e });
      break;
    default:
      r = null;
      break;
  }
  return i ? (a = a + " min-w-[36px] w-[36px] px-0 pl-0 pr-0", y && (a = a + " h-[36px]")) : r && (c === "right" ? a = a + " pl-4 pr-3 py-0 py-0" : a = a + " pl-3 pr-4 py-0 py-0"), /* @__PURE__ */ s.jsxs(
    "button",
    {
      type: I,
      style: {
        ...N,
        overflow: "hidden"
      },
      className: a,
      disabled: f,
      ref: L,
      ...E,
      children: [
        f ? null : c === "left" && r,
        i ? null : v,
        f ? null : c === "right" && r
      ]
    }
  );
};
export {
  Qe as Button
};
